const defaultState = {
  access_token: JSON.parse(localStorage.getItem("loopback-token"))
};

export default defaultState;
